var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMyListSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AFB156F3-5361-4A8A-821B-D819384D9CF5@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google-TV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chairside-Education-overview,-Captions-button-focused-with-CC-off",
    transform: "translate(-310.000000, -616.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/NAV/My-list/Grey-Copy",
    transform: "translate(310.000000, 616.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1629509,0.707106781 L35.5771645,2.12132034 C35.9676888,2.51184464 35.9676888,3.14500961 35.5771645,3.53553391 L11.5355339,27.5771645 C11.4563622,27.6563362 11.3672179,27.7194573 11.2721445,27.7665277 L11.3137085,27.7279221 C10.9231842,28.1184464 10.2900192,28.1184464 9.89949494,27.7279221 L0.707106781,18.5355339 C0.316582489,18.1450096 0.316582489,17.5118446 0.707106781,17.1213203 L2.12132034,15.7071068 C2.51184464,15.3165825 3.14500961,15.3165825 3.53553391,15.7071068 L10.6412136,22.8132136 L32.7487373,0.707106781 C33.1392616,0.316582489 33.7724266,0.316582489 34.1629509,0.707106781 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyListSelected);
export default __webpack_public_path__ + "static/media/ic_my_list_selected.d372d3b3.svg";
export { ForwardRef as ReactComponent };